import { Data, Modal as ModalModule, UI, Utils } from 'common';
import isFunction from 'lodash/isFunction';
import moment from 'moment';
import React, { Component } from 'react';
import DateRangeType from './shared/DateRangeType.enum';
import RefundTypeOptions from './shared/RefundTypeOptions';
import StatusOptions from './shared/StatusOptions';
import HistoryUtil from './utils/Util';

const { AllCarriers, CalculatedData, DateRangeOptions, DateRange } = Data;

const { withLayoutAndModalContexts, Util } = Utils;

const {
	ServiceFieldWithLabel,
	WrappedCalendar,
	WrappedRadioButton,
	WrappedInputTextWithLabel,
	WrappedDropdownWithLabel,
} = UI;

const { Modal } = ModalModule;

class AdvancedSearchModal extends Component {
	constructor(props) {
		super(props);
		const { data = {} } = props;
		const { dateRangeValue, users = [] } = data;

		const defaultStateObject = this.buildDefaultStateObject(dateRangeValue);

		this.state = {
			...defaultStateObject,
			allServices: [
				{
					serviceName: 'Any',
					serviceType: 'any',
				},
				...CalculatedData.allServices,
			],
			allCarriers: [
				{
					displayName: 'Any',
					value: 'any',
				},
				...AllCarriers,
			],
			dateRangeOptions: DateRangeOptions.map(dateRangeOption => ({
				...dateRangeOption,
				label:
					dateRangeOption.value === DateRange.Custom
						? 'Custom'
						: dateRangeOption.label,
			})),
			users: users.map(user => ({
				label: user.UserName,
				value: user.UserId,
			})),
		};
	}

	componentDidMount() {
		const { dateRangeType, dateRangeValue, dateRangeStart, dateRangeEnd } =
			this.state;
		const localState =
			JSON.parse(localStorage.getItem('searchModalState')) || {};

		const {
			dateRangeValue: localDateRangeValue,
			dateRangeStart: localDateRangeStart,
			dateRangeEnd: localDateRangeEnd,
			dateRangeType: localDateRangeType,
			toName,
			printMessage,
			trackingNumbers,
			status,
			carriers,
			serviceTypes,
			refundType,
			user,
			costCodes,
		} = localState;

		this.setState({
			dateRangeStart: localDateRangeStart
				? new Date(localDateRangeStart)
				: dateRangeStart,
			dateRangeEnd: localDateRangeEnd
				? new Date(localDateRangeEnd)
				: dateRangeEnd,
			dateRangeValue: localDateRangeValue || dateRangeValue,
			dateRangeType: localDateRangeType || dateRangeType,
			toName,
			printMessage,
			trackingNumbers,
			status,
			carriers,
			serviceTypes,
			refundType,
			user,
			costCodes,
		});
	}

	buildDefaultStateObject = defaultDateRangeValue => {
		const dateRange = this.calculateDateRange(defaultDateRangeValue);

		return {
			dateRangeType: DateRangeType.TransactionDate,
			...dateRange,
			toName: '',
			costCodes: '',
			user: '',
			printMessage: '',
			trackingNumbers: '',
			serviceTypes: '',
			status: '',
			refundType: '',
			carriers: '',
		};
	};

	/**
	 * Return an object containing 'dateRangeStart', 'dateRangeEnd' and 'dateRangeValue'
	 * @param {DateRangeOption} dateRangeOption
	 * @returns {object}
	 */
	calculateDateRange = dateRangeOption => {
		const dateRangeValue = dateRangeOption || DateRange.Past30Days;
		const { dateRangeStart } = Util.calculateDateRange(dateRangeValue);

		return {
			dateRangeStart,
			dateRangeEnd: new Date(),
			dateRangeValue,
		};
	};

	onChange = e => {
		const { name, value } = e.target;

		this.setState({
			[name]: value,
		});
	};

	onDateChange = e => {
		const { name, value } = e.target;

		if (name === 'dateRangeValue') {
			const dateRange = this.calculateDateRange(value);

			this.setState(dateRange);
		} else {
			this.setState({
				[name]: value,
			});
		}
	};

	onServiceChange = ({ value }) => {
		this.setState({
			serviceTypes: value,
		});
	};

	ondDateRangeChange = e => {
		const { name, value } = e.target;
		const { dateRangeStart, dateRangeEnd } = this.state;

		// set date range to custom whenever From or Start changes
		this.setState({ dateRangeValue: DateRange.Custom });
		if (name === 'dateRangeStart') {
			if (moment.isDate(value)) {
				this.setState({
					[name]: value,
					dateRangeEnd: moment(value).isAfter(moment(dateRangeEnd))
						? value
						: dateRangeEnd,
				});
			}
		} else if (name === 'dateRangeEnd') {
			if (moment.isDate(value)) {
				this.setState({
					[name]: value,
					dateRangeStart: moment(value).isBefore(moment(dateRangeStart))
						? value
						: dateRangeStart,
				});
			}
		}
	};

	onSearchClick = () => {
		const {
			data: { searchPrints },
			modalId,
			modalContext,
		} = this.props;
		const {
			dateRangeType,
			dateRangeStart,
			dateRangeEnd,
			toName,
			costCodes,
			user,
			printMessage,
			trackingNumbers,
			serviceTypes,
			status,
			refundType,
			carriers,
		} = this.state;

		const searchFilter = HistoryUtil.buildSearchFilterByAdvancedSearchFilter({
			dateRangeType,
			dateRangeStart,
			dateRangeEnd,
			toName,
			costCodes,
			user,
			printMessage,
			trackingNumbers,
			serviceTypes,
			status,
			refundType,
			carriers,
		});

		if (isFunction(searchPrints)) {
			searchPrints(searchFilter);
		}

		modalContext.closeModal(modalId);

		localStorage.setItem('searchModalState', JSON.stringify({ ...this.state }));
	};

	onResetClick = () => {
		const defaultStateObject = this.buildDefaultStateObject();

		this.setState(defaultStateObject);

		localStorage.setItem(
			'searchModalState',
			JSON.stringify({ ...defaultStateObject })
		);
	};

	render() {
		const {
			layoutContext: { isMobile },
			modalId,
			data = {},
		} = this.props;
		const { costCodeOptions = [] } = data;

		const {
			dateRangeType,
			dateRangeValue,
			dateRangeStart,
			dateRangeEnd,
			allCarriers,
			allServices,
			toName,
			costCodes,
			user,
			users,
			printMessage,
			trackingNumbers,
			serviceTypes,
			status,
			refundType,
			carriers,
			dateRangeOptions,
		} = this.state;

		const mobileClassName = isMobile ? 'mobile-wrapper' : '';

		return (
			<Modal
				modalId={modalId}
				header="Advanced Search"
				className="history history-advanced-search-modal"
				primaryButton={{
					text: 'Search',
					onClick: this.onSearchClick,
					dataqa: 'advanced-search-search-button',
				}}
				secondaryButton={{
					text: 'Reset',
					onClick: this.onResetClick,
					dataqa: 'advanced-search-reset-button',
				}}
				size="large"
			>
				<div className="p-grid p-nogutter">
					<div className="p-col-12 date-row">
						<p>Date:</p>
						<div className="radio-option">
							<WrappedRadioButton
								name="dateRangeType"
								inputId="advanced-search-transaction-date"
								value={DateRangeType.TransactionDate}
								checked={dateRangeType === DateRangeType.TransactionDate}
								onChange={this.onDateChange}
								dataqa="advanced-search-transaction-date"
							>
								Date Printed
							</WrappedRadioButton>
						</div>
						<div className="radio-option">
							<WrappedRadioButton
								name="dateRangeType"
								inputId="advanced-search-delivered-date"
								value={DateRangeType.DeliveredDate}
								checked={dateRangeType === DateRangeType.DeliveredDate}
								onChange={this.onDateChange}
								dataqa="advanced-search-delivered-date"
							>
								Date Delivered
							</WrappedRadioButton>
						</div>
						<div className="radio-option">
							<WrappedRadioButton
								name="dateRangeType"
								inputId="advanced-search-ship-date"
								value={DateRangeType.ShipDate}
								checked={dateRangeType === DateRangeType.ShipDate}
								onChange={this.onDateChange}
								dataqa="advanced-search-ship-date"
							>
								Ship Date
							</WrappedRadioButton>
						</div>
					</div>
					<WrappedDropdownWithLabel
						className={`p-col-6 ${mobileClassName}`}
						label="Date Range:"
						uiElementConfig={{
							name: 'dateRangeValue',
							value: dateRangeValue,
							options: dateRangeOptions,
							optionLabel: 'label',
							optionValue: 'value',
							onChange: this.onDateChange,
							dataqa: 'advanced-search-date-range',
						}}
					/>
					<div className="custom-date-range-inputs p-col-6">
						<div className="label-container from">
							<p>From:</p>
						</div>
						<WrappedCalendar
							id="dateRangeStart"
							className="date-range-input"
							value={dateRangeStart}
							name="dateRangeStart"
							maxDate={new Date()}
							placeholder="mm/dd/yy"
							dateFormat="mm/dd/yy"
							onChange={this.ondDateRangeChange}
							maxLength={10}
							required
							dataqa="advanced-search-date-range-start"
						/>
						<div className="label-container to">
							<p>To:</p>
						</div>
						<WrappedCalendar
							className="date-range-input"
							value={dateRangeEnd}
							name="dateRangeEnd"
							maxDate={new Date()}
							placeholder="mm/dd/yy"
							dateFormat="mm/dd/yy"
							onChange={this.ondDateRangeChange}
							maxLength={10}
							required
							dataqa="advanced-search-date-range-end"
						/>
					</div>
					<div className="p-col-12">
						<hr />
					</div>
					<WrappedInputTextWithLabel
						className={`p-col-6 ${mobileClassName}`}
						label="Recipient:"
						uiElementConfig={{
							type: 'text',
							name: 'toName',
							maxLength: 42,
							placeholder: 'Any',
							value: toName,
							onChange: this.onChange,
							dataqa: 'advanced-search-to-name',
						}}
					/>
					<WrappedDropdownWithLabel
						className={`p-col-6 ${mobileClassName}`}
						label="Cost Code:"
						uiElementConfig={{
							name: 'costCodes',
							placeholder: 'Any',
							options: costCodeOptions,
							optionLabel: 'code',
							optionValue: 'id',
							value: costCodes,
							onChange: this.onChange,
							dataqa: 'advanced-search-cost-codes',
						}}
					/>
					<WrappedDropdownWithLabel
						className={`p-col-6 ${mobileClassName}`}
						label="User:"
						uiElementConfig={{
							name: 'user',
							placeholder: 'Any',
							options: users,
							optionLabel: 'label',
							optionValue: 'value',
							value: user,
							onChange: this.onChange,
							dataqa: 'advanced-search-user',
						}}
					/>
					<WrappedInputTextWithLabel
						className={`p-col-6 ${mobileClassName}`}
						label="Print Message:"
						uiElementConfig={{
							type: 'text',
							name: 'printMessage',
							placeholder: 'Any',
							value: printMessage,
							onChange: this.onChange,
							dataqa: 'advanced-search-print-message',
						}}
					/>
					<div className="p-col-12">
						<hr />
					</div>
					<WrappedInputTextWithLabel
						className={`p-col-6 ${mobileClassName}`}
						label="Tracking #:"
						uiElementConfig={{
							type: 'text',
							name: 'trackingNumbers',
							maxLength: 42,
							placeholder: 'Any',
							value: trackingNumbers,
							onChange: this.onChange,
							dataqa: 'advanced-search-tracking-numbers',
						}}
					/>
					<ServiceFieldWithLabel
						className={`p-col-6 ${mobileClassName}`}
						label="Service:"
						uiElementConfig={{
							showServicesOnly: true,
							enableGrouping: false,
							name: 'serviceTypes',
							placeholder: 'Any',
							options: allServices,
							optionLabel: 'serviceName',
							optionValue: 'serviceType',
							value: serviceTypes,
							onChange: this.onServiceChange,
							dataqa: 'advanced-search-service',
						}}
					/>
					<WrappedDropdownWithLabel
						className={`p-col-6 ${mobileClassName}`}
						label="Status:"
						uiElementConfig={{
							name: 'status',
							placeholder: 'Any',
							options: StatusOptions,
							optionLabel: 'label',
							optionValue: 'value',
							value: status,
							onChange: this.onChange,
							dataqa: 'advanced-search-status',
						}}
					/>
					<WrappedDropdownWithLabel
						className={`p-col-6 ${mobileClassName}`}
						label="Refund Type:"
						uiElementConfig={{
							name: 'refundType',
							placeholder: 'Any',
							options: RefundTypeOptions,
							optionLabel: 'label',
							optionValue: 'value',
							value: refundType,
							onChange: this.onChange,
							dataqa: 'advanced-search-refund-type',
						}}
					/>
					<WrappedDropdownWithLabel
						className={`p-col-6 ${mobileClassName}`}
						label="Carrier:"
						uiElementConfig={{
							name: 'carriers',
							placeholder: 'Any',
							options: allCarriers,
							optionLabel: 'displayName',
							optionValue: 'value',
							value: carriers,
							onChange: this.onChange,
							dataqa: 'advanced-search-carriers',
						}}
					/>
				</div>
			</Modal>
		);
	}
}

export default withLayoutAndModalContexts(AdvancedSearchModal);
